<!-- cancel-future-appointment.component.html -->
<app-entity-mat-dialog-title [title]="dialogTitle"></app-entity-mat-dialog-title>

<form (ngSubmit)="onSubmit(f)" #f="ngForm" class="form">
  <div *ngIf="lessonsToDelete.length > 0">
    <div class="delete-warning-header">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
      <span *ngIf="_injectedDialogData?.['data']?.['bundle'] === 'lesson'">The following lessons will be deleted:</span>
      <span *ngIf="_injectedDialogData?.['data']?.['bundle'] === 'schedules'">The following schedules will be deleted:</span>
      <span *ngIf="_injectedDialogData?.['data']?.['bundle'] === 'services'">The following services will be deleted:</span>
      <span *ngIf="_injectedDialogData?.['data']?.['bundle'] === 'group_lesson'">The following group lessons will be deleted:</span>
    </div>

    <div class="delete-count">
      <i class="fa fa-trash" aria-hidden="true"></i>
      {{ lessonsToDelete.length }} event{{ lessonsToDelete.length > 1 ? 's' : '' }} will be permanently deleted
    </div>

    <div class="scrollable-list mb-3">
      <ul>
        <li *ngFor="let lesson of lessonsToDelete">
          <div class="event-date">
            <i class="fa fa-calendar" aria-hidden="true"></i>
            {{ lesson.date | date:'EEEE, MMMM d, y' }} at {{ lesson.date | date:'h:mm a' }}
            <span class="badge rounded-pill text-bg-secondary ms-auto fw-normal">{{ lesson.status_name || 'No status' }}</span>
          </div>
          <div *ngIf="lesson.attendees && lesson.attendees.length > 0" class="event-attendees">
            <i class="fa fa-users" aria-hidden="true"></i>
            {{ lesson.attendees.join(', ') }}
          </div>
        </li>
      </ul>
    </div>
  </div>

  <div *ngIf="lessonsToDelete.length === 0 && !showProgressSpinner" class="empty-state">
    <i class="fa fa-check-circle" aria-hidden="true"></i>
    <h2 *ngIf="_injectedDialogData?.['data']?.['bundle'] === 'lesson'">No future lessons found to delete.</h2>
    <h2 *ngIf="_injectedDialogData?.['data']?.['bundle'] === 'schedules'">No future schedules found to delete.</h2>
    <h2 *ngIf="_injectedDialogData?.['data']?.['bundle'] === 'services'">No future services found to delete.</h2>
    <h2 *ngIf="_injectedDialogData?.['data']?.['bundle'] === 'group_lesson'">No future group lessons found to delete.</h2>
  </div>

  <app-error-message [message]=this.errorMessage></app-error-message>

  <div style="min-height:150px" *ngIf="showProgressSpinner">
    <mat-progress-spinner class="matProgressSpinnerCentered"
        *ngIf="showProgressSpinner" mode="indeterminate">
    </mat-progress-spinner>
  </div>

  <div class="dialog-actions">
    <button class="btn btn-cancel" mat-button type="button" (click)="onCancel()">Cancel</button>
    <button class="btn btn-delete" mat-button type="submit" [disabled]="lessonsToDelete.length === 0">
      <i class="fa fa-trash" aria-hidden="true"></i> Delete {{ lessonsToDelete.length }} Event{{ lessonsToDelete.length > 1 ? 's' : '' }}
    </button>
  </div>
</form>
